import React, { ReactElement } from "react";
import { FooterProps } from "./footer.types";
import classNames from "classnames";

export const Footer = ({
  ariaLabel = "Visit the Sabre website",
  signature,
  yearRange,
  links,
  social,
  customLogo,
  ...rest
}: FooterProps): ReactElement => {
  const SabreLogo = (): ReactElement => (
    <a
      href={"http://www.sabre.com"}
      className="spark-footer__logo spark-hidden--lte-sm"
      aria-label={ariaLabel}
    >
      <i className="spark-logo spark-logo--sabre spark-logo--xs" />
    </a>
  );
  const renderLinks = (): ReactElement => {
    return (
      <ul className="spark-footer__list">
        {links?.map((link) => {
          const { text, url, onClick, onKeyDown, ...other } = link;

          const normalizedUrl = url || "#";

          return (
            <li className="spark-footer__list-item" key={text}>
              <a
                href={normalizedUrl}
                title={text}
                {...other}
                className={classNames(
                  "spark-footer__list-link",
                  link.className
                )}
                onClick={(e): void => {
                  if (normalizedUrl === "#") {
                    e.preventDefault();
                  }
                  onClick?.(e);
                }}
              >
                {text}
              </a>
            </li>
          );
        })}
      </ul>
    );
  };
  const renderSocial = (): ReactElement | null => {
    if (typeof social !== "object") {
      return null;
    }

    type socialKeys = keyof typeof social;

    const sites = (Object.keys(social) as socialKeys[]).filter(
      (site) => social[site] !== null
    );

    return sites.length === 0 ? null : (
      <ul className="spark-footer__list spark-footer__list--right spark-footer__list--icons">
        {sites.map((site) => (
          <li className="spark-footer__list-item" key={site}>
            <a
              href={social[site]}
              className="spark-footer__list-link"
              title={site}
            >
              <i className={`spark-icon-social-${site} spark-icon--fill`} />
            </a>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <footer
      {...rest}
      style={{ flexShrink: 0, ...rest.style }}
      className={classNames("spark-footer", rest.className)}
    >
      <div className="container">
        {customLogo ? customLogo : <SabreLogo />}
        <div className="spark-footer__content">
          <div className="spark-footer__copyright">
            © {yearRange}{" "}
            {signature && (
              <span className="spark-hidden--lte-md">{signature}</span>
            )}
          </div>
          {links?.length ? renderLinks() : null}
        </div>
        {social && renderSocial()}
      </div>
    </footer>
  );
};
